import $ from 'jquery';
import {is_google_maps_loaded,sendAnalyticsInfo,SUTIL,isNoDataError,software_use_events} from 'h2g-test-results/js/util';

angular.module('WTG.TRACEROUTE', [])
.factory('tracerouteData', function($rootScope) {
 var tr_results = {};
 function set(data) {
  tr_results = data;
 }
 function get() {
  return tr_results;
 }
 function goBackToOneView() {
  if(!C11N.is_portal) $rootScope.goBackToOneView();
 }
 return {
  set: set,
  get: get,
  goBack : goBackToOneView
 };
})
.directive('wtgTraceroute', function() {
 return {
  restrict: 'E',
  templateUrl: C11N.root_path +'traceroute/templates/traceroute.html',
  controller:'mapsCtrl as ctrl'
 };
})
.controller('mapsCtrl', function($scope, $rootScope,$timeout,$interval,TESTRESULTS,WTGDIALOG,tracerouteData) {
 $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time);
 var self = this;
 $scope.$on('$ionicView.enter', function(){
  setStatusBarColor('main_ui');
  H2GAPP.setTitle(false,$rootScope.strings.trace_route_header_title);
  sendAnalyticsInfo({id:software_use_events.trace_route});
 });
 var traceroute_data = tracerouteData.get();
 $scope.history_show = traceroute_data && traceroute_data.history;
 console.log("$scope.history_show--"+$scope.history_show);
 $scope.selected_ip = "";
 self.simulateQuery = true;
 self.querySearch = querySearch;
 $scope.placeHolder = $rootScope.strings.add_destination;
 $scope.isDisabled = false;
 $scope.icon_src = C11N.root_path + "traceroute/img/down-arrow.svg";
 self.selectedItemChange = selectedItemChange;
 self.searchTextChange = searchTextChange;
 var mapOptions = {};
 $scope.map;
 self.addDestination = addDestination;
 self.deleteHostAddressFromStorage = deleteHostAddressFromStorage;
 $scope.Timer = null;
 $scope.convert_data = function(results){
  var res_data = {};
  if(results && results.h){
   for(var item in results.h){
    var key = results.h[item].an || results.h[item].hn;
    res_data[key] = results.h[item];
   }
  }else
  L.trace("getTraceRouteTestResults-- no results found");
  return res_data;
 };
 var tr_data = TESTRESULTS.getTraceRouteResults();
 tr_data.results = $scope.convert_data(tr_data.results);
 L.trace("tr_data--"+JSON.stringify(tr_data));
 $scope.iPList = Object.keys(tr_data.results).map(function(x){ return x});
 $scope.selectedItem = $scope.iPList[0];
 if(is_google_maps_loaded()){
  mapOptions = {
   //center: new google.maps.LatLng(clat, clng),
   zoom: 12,
   mapTypeId: google.maps.MapTypeId.ROADMAP,
   minZoom: 1,
   maxZoom: 15,
   disableDefaultUI: true
  };
  $scope.map = new google.maps.Map(document.getElementById("dvMap"), mapOptions);
 }
 $scope.fetch_traceroute_data = function fetch_data(){
  L.trace("fetch_traceroute_data");
  tr_data = TESTRESULTS.getTraceRouteResults();
  tr_data.results = $scope.convert_data(tr_data.results);
  if(!$scope.selected_ip && tr_data && tr_data.results && Object.keys(tr_data.results).length) $scope.selected_ip = Object.keys(tr_data.results)[0];
  if(tr_data.results[$scope.selected_ip]){
   $scope.drawVisualTraceRoute($scope.selected_ip);
   if(!C11N.is_portal){
    get_json("user_settings.servers.app_servers",function(err,app_ser){
     if(err) return L.error("get Trace Route Destination List-error-"+err);
     $scope.setTraceRouteDestinationList(app_ser);
    });
   }
  }
 };
 $scope.drawVisualTraceRoute = function drawVisualTraceRoute(index){
  L.trace("drawVisualTraceRoute");
  if(!is_google_maps_loaded()){
   $rootScope.hideBusyScreen();
   //TODO : hard coded strings
   return WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup, { header: "Visual Trace Route" ,
    body:  "Map not loaded please try after some time", btn_two:$rootScope.strings.cancel_btn, btn_one: $rootScope.strings.retry_btn,
    cb_two: function(){
     L.trace("retry dialog ctrl - NO");
     tracerouteData.goBack();
    },
    cb_one: function(){
     $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time);
     $scope.drawVisualTraceRoute(index);
    }
   });
  }
  $rootScope.hideBusyScreen();
  L.trace("drawVisualTraceRoute -- index--"+index);
  var traceRouteRes = tr_data.results;
  $scope.tr_found = true;
  $scope.test = tr_data.test;
  //$scope.ts = tr_data.time_stamp;
  $scope.tid = tr_data.test_id;
  $scope.notAvailable = $rootScope.strings.trace_route_not_available;
  $scope.test_done = false;

  var hasFocus = $('#autoCompleteId') && $('#autoCompleteId').is(':focus');
  if(!hasFocus) $scope.selectedItem = index;

  //L.trace("getTraceRouteTestResults-testData-"+JSON.stringify(traceRouteRes[index].trace_route));
  //updatedropdownvalues();
  $scope.iPList = Object.keys(tr_data.results).map(function(x){ return x});
  var trace_route_data = traceRouteRes[index] && traceRouteRes[index].tr || "";
  var latency_array = trace_route_data && trace_route_data.map(function(x){return x.l});
  L.trace("Main latency array--"+JSON.stringify(latency_array));

  function prepare_avg_latency_between_hops(lat_arr,hop,at){
   var cur_hop_index , next_highest_val , next_highest_val_index , cur_hop_index_in_sor_ary , avg_time ;
   cur_hop_index = lat_arr.findIndex(function(x){ return (x == hop)}); // current  hop index in main array
   var b = lat_arr.slice();             // duplicate array for sorting
   b.sort(function(a,b){return (a-b)});
   cur_hop_index_in_sor_ary = b.findIndex(function(x){ return (x == hop)});   // current  hop index in sorted array
   next_highest_val = b[cur_hop_index_in_sor_ary+1];    // next highest value of current hop from sorted array
   next_highest_val_index = lat_arr.findIndex(function(x){ return (x == next_highest_val)});  // next highest value position in main array

   if(next_highest_val_index != cur_hop_index)
   avg_time = Math.round((lat_arr[next_highest_val_index] - lat_arr[cur_hop_index])/(next_highest_val_index-cur_hop_index));
   else
   avg_time = 0;

   lat_arr[cur_hop_index] = at;
   for(var i1=cur_hop_index+1; i1<next_highest_val_index; i1++){
    lat_arr[i1] = avg_time || 1 ;  // replace all latencies with average times between current hop and next minimum highest hop
   }
   if(next_highest_val) prepare_avg_latency_between_hops(lat_arr,next_highest_val,avg_time);
  }
  if(latency_array && latency_array.length) {
   var minValue = Math.min.apply(null, latency_array.filter(function(x){ return x > -1 }));
   if(latency_array[0] != minValue ) {
    latency_array[0] = minValue-1;
    minValue = minValue-1;
   }
   prepare_avg_latency_between_hops(latency_array,minValue,minValue);
  }
  L.trace("final latency array--"+JSON.stringify(latency_array));

  var slowest_hop = "";
  var _tr = [];
  var temp = {};
  var traceroute_success = false;
  var des_loc_found = false;
  var dl = tr_data.dev_loc;
  $scope.device_location = WTG.fmt($rootScope.strings.trace_route_your_device_loc,{"device_ip":dl.ip});
  while($scope.markers.length) $scope.markers.pop().setMap(null);
  while($scope.lines.length) $scope.lines.pop().setMap(null);
  if(!trace_route_data.length) {
   $scope.tr_found = false;
   $scope.error_text = $rootScope.strings.no_data_available;
   return;
  }

  var tlat = dl && dl.loc && dl.loc.lat || "";
  var tlng = dl && dl.loc && dl.loc.lng || "";
  if(tlat && tlng){
   temp = {address : "",ttl: 0,lat : tlat,lng:tlng};
   _tr.push(temp);
  }

  var _ti = traceRouteRes[index];
  var des_ip = _ti.ha;
  var des_loc = _ti && _ti.loc || "";
  var des_lat = des_loc.lat || "";
  var des_lng = des_loc.lng || "";
  var total_lat = "";
  var length = trace_route_data.length;
  for(var i2=0;i2<length;i2++) {
   var td = trace_route_data[i2];
   if(td.ip == des_ip) {
    traceroute_success = true;
    total_lat = td.l;
   }else if(td.loc && td.loc.lat && td.loc.lng) {
    var add = "";
    if(td.pn) add = td.pn;
    if(td.c) add += (", " + td.c);
    if(td.co) add += (", " + td.co);
    temp = {address : add, ttl: td.ttl,lat :td.loc.lat,lng:td.loc.lng};
    _tr.push(temp);
   }
  }
  if(des_lat && des_lng){
   des_loc_found = true;
   var last_ttl = traceroute_success ? trace_route_data[length-1].ttl : (_tr.length ? (_tr[_tr.length-1].ttl) + 1 : "");
   temp = {address:get_destination_addr(),ttl:last_ttl,lat : des_lat,lng:des_lng};
   _tr.push(temp);
  }

  function get_destination_addr(){
   var des_add = "";
   if(_ti.pn) des_add += _ti.pn;
   if(_ti.c) des_add += (", " + _ti.c);
   if(_ti.co) des_add += (", " + _ti.co);
   if(des_add) des_add += '<br>' ;
   des_add += (_ti.hn ? _ti.hn : _ti.ha);
   if(!traceroute_success)des_add += " " +$rootScope.strings.trace_route_not_reached ;
   return des_add;
  }


  $scope.des_add = get_destination_addr() ;
  $scope.des_loc_found = des_loc_found;
  //L.trace("getTraceRouteTestResults- _tr-"+JSON.stringify(_tr));
  $scope.iPAddress = trace_route_data;
  $scope.circlebg = traceroute_success ? "#000000" : "#bf4d4a" ;
  $scope.start_img = C11N.root_path + "traceroute/img/ic_trace_start.png" ;
  $scope.end_img = C11N.root_path + "traceroute/img/ic_trace_target.png" ;
  $scope.loader = WTG.img("three-dots.svg");
  $scope.destination_str = $rootScope.strings.placeholder_dest_str;
  $scope.ping = traceroute_success;
  $scope.searchResult = traceRouteRes[index].traceroute_success;
  $scope.circlewidth = "25px";
  // Don't use "xtract" method here.because some times we are getting index values as ip addresses like 8.8.8.8.
  // The xtract function trying to split the object (8.8.8.8) and searching for inner 8 object
  $scope.test_done = (['done','limit-reached','stopped'].indexOf(traceRouteRes[index].s)!=-1);
  var failure_hop_ttl = 0;
  if($scope.test_done && ['limit-reached','stopped'].indexOf(traceRouteRes[index].s)!=-1){
   for(var i3=length-1;i3>0;i3--){
    if(trace_route_data[i3].l != -1){
     failure_hop_ttl = trace_route_data[i3].ttl;
     break;
    }
   }
  }
  L.trace("traceroute--   failure_hop_ttl "+ failure_hop_ttl );
  L.trace("traceroute--   $scope.test_done "+ $scope.test_done );
  $scope.getColor = function(ttl/*,index*/){
   var event = Object.keys(_tr).some(function(x) { return _tr[x].ttl==ttl });
   var textclr = event ? "#749935" : "#C5C5C5";
   return $scope.myObj = {
    "color" : textclr
   };
  };
  $scope.getBgColor = function(item,i) {
   var res = Math.floor(latency_array[i])>100;
   var bgclr = (i == (length-1) && !traceroute_success && $scope.test_done) ? "#bf4d4a" : (res ? "#D1A92F" : "#749935") ;
   return $scope.myObj = {
    "background-color" : bgclr
   };
  };
  $scope.getMargin = function(selector/*,item*/){
   var lLeft = ((parseInt( $(selector).css("height"))/2)-1)+parseInt( $(selector).css("margin-left"))+"px";
   return $scope.myObj = {
    "background-color" : "#749935" ,
    "margin-left" :lLeft
   };
  };

  $scope.getLatency = function(item,i){
   var str = "*";
   if((item.l>0)){
    str = Math.floor(latency_array[i]) + $rootScope.strings.settings_time_unit_milliseconds_short;
    if(item.d) str += " " + WTG.fmt($rootScope.strings.trace_route_list_distance,{"distance":Math.floor(item.d) });
    if(item.ip) str +=" " + WTG.fmt($rootScope.strings.trace_route_list_to_ip,{"ip":item.ip});
   }
   return str;
  };

  $scope.getCity = function(item/*,index*/){
   var str = "";
   if((item.l>0)){
    if(item.ttl == 1) str = $rootScope.strings.trace_route_map_gateway;
    if(!(item.pn || item.c || item.co)) {
     if(item.ttl != 1)str = $rootScope.strings.trace_route_internal_hop;
    } else {
     if(item.pn) str += item.pn;
     if(item.c) str += (", " + item.c);
     if(item.co) str += (", " + item.co);
    }
   }else{
    str = $rootScope.strings.trace_route_invisible_hop;
   }
   return str;
  };
  $scope.isDeleted = function(selector){
   return !C11N.is_portal && (!$scope.history_show && $scope.app_ser) &&
   Object.keys($scope.app_ser).some(function(x){return $scope.app_ser[x]==selector});
  };
  if(!$scope.test_done) $('#mapDescDiv').animate({ scrollTop: $('#mapDescDiv')[0].scrollHeight}, 2000);


  var max_latency = Math.max.apply(null, latency_array) ;

  function get_hops_list(la,ml){
   var hl = [];
   la.forEach(function(x,i){if((x==ml) && trace_route_data[i].l>0) hl.push(i+1);});
   //As per our latency calculation Some times we are getting a chance to max latency for anonymous hops.
   //but we are noe showing latency of  anonymous hops on description. so we have to calculate next highest latency hop details.
   if(!hl.length) {
    la.splice(la.indexOf(ml), 1); // remove max from the array
    var next_max = Math.max.apply(null, la);
    return get_hops_list(la,next_max);
   }
   return hl;
  }
  var hopList = get_hops_list(latency_array,max_latency);
  L.trace("hopList=="+JSON.stringify(hopList));
  var slowest_hop_details = "";
  if(hopList.length>1){
   var hop_positions = "  ";
   hopList.forEach(function(item,i){
    hop_positions += (i==0) ? item : (" , "+item);
   });
   slowest_hop_details = WTG.fmt($rootScope.strings.trace_route_summary_multiple_slowest_hops,{"max_latency":Math.floor(max_latency),"hop_positions":hop_positions});
  }else if(hopList.length) {
   slowest_hop = hopList[0];
   slowest_hop_details = WTG.fmt($rootScope.strings.trace_route_summary_single_slowest_hop,{"max_latency":Math.floor(max_latency),"hop1":(slowest_hop-1),"hop2":slowest_hop});
  }
  if(traceroute_success){
   if(traceRouteRes[index].d > 1)
   $scope.test_summary = WTG.fmt($rootScope.strings.trace_route_summary,{"total_hops":length,"distance": traceRouteRes[index].d,"latency":Math.floor(total_lat)});
   else
   $scope.test_summary = WTG.fmt($rootScope.strings.trace_route_summary_no_distance,{"total_hops":length,"latency":Math.floor(total_lat)});

   $scope.test_summary += " "+slowest_hop_details;
  }else {
   var endpoint_name = _ti.hn || des_ip ;
   $scope.test_summary = WTG.fmt($rootScope.strings.trace_route_failure_summary,{"endpoint_name":endpoint_name,"hop_number":failure_hop_ttl+1});
  }

  if(!_tr.length) return;

  var clat = _tr[0].lat || "48.137154";
  var clng = _tr[0].lng || "11.576124";
  var map = $scope.map;
  $scope.onMarkerCurrentLocation = function(ttl,i){
   if(!traceroute_success && ttl == trace_route_data[length-1].ttl && des_lat && des_lng) clickroute(des_lat,des_lng);
   L.trace("onMarkerCurrentLocation --ttl"+ttl+"--index--"+i);
   var trentry = _tr.find(function(x) { return x.ttl==ttl });
   if(!trentry) return;
   clat = trentry.lat ;
   clng = trentry.lng ;
   if(clat && clng) clickroute(clat,clng);
   else if((!i) && tlat && tlng ) clickroute(tlat,tlng);
  };
  var infoWindow = new google.maps.InfoWindow();
  var lat_lng = [];
  var latlngbounds = new google.maps.LatLngBounds();
  for (var i4 = 0; i4 < _tr.length; i4++) {
   var data = _tr[i4];
   var markerColor = (i4 == _tr.length-2 && !traceroute_success && $scope.test_done)? "#bf4d4a" : "#000000";
   var myLatlng = new google.maps.LatLng(data.lat, data.lng);
   lat_lng.push(myLatlng);

   var icon;
   if((data.ttl == 0) || ($scope.test_done && (i4 == _tr.length-1) && des_loc_found)){
    icon = {
     url: data.ttl==0 ? C11N.root_path + "traceroute/img/start.png" :
     traceroute_success ? C11N.root_path + "traceroute/img/destination.png" : C11N.root_path + "traceroute/img/destination_un_success.png",
     scaledSize: new google.maps.Size(35, 35), // scaled size
     origin: new google.maps.Point(0,0), // origin
     anchor: new google.maps.Point(13, 10) // anchor
    };
   }else{
    icon = {
     path: google.maps.SymbolPath.CIRCLE,
     scale : 3,
     strokeWeight: 0,
     strokeOpacity: 0,
     fillColor: markerColor,
     fillOpacity: 1,
    };
   }
   var marker = new google.maps.Marker({
    position: myLatlng,
    map: map,
    icon: icon
   });
   latlngbounds.extend(marker.position);
   (function (m, d) {
    google.maps.event.addListener(m, "click", function (/*e*/) {
     if(d.address) {
      infoWindow.setContent(d.address);
      infoWindow.open(map, m);
     }

    });
   })(marker, data);
   $scope.markers.push(marker);
  }
  map.setCenter(latlngbounds.getCenter());
  map.fitBounds(latlngbounds);
  var lineIcon = [{ icon: {
   path: 'M 0,-1 0,1',
   strokeOpacity: 1,
   scale: 2
  },
  offset: '0',
  repeat: '10px'
 }];
 for (var i5 = 0; i5 < lat_lng.length-1; i5++) {
  var pingSuccess = ($scope.test_done && (i5==lat_lng.length-2) && !traceroute_success) ? false : true;
  var pathClr = pingSuccess ? "#749935" : "#bf4d4a" ;
  var PathStyle = new google.maps.Polyline({
   path: [lat_lng[i5], lat_lng[i5+1]],
   strokeColor: pathClr,
   strokeOpacity:  pingSuccess ? 1 : 0,
   strokeWeight: 2,
   icons: pingSuccess ? "" : lineIcon,
   map: map
  });
  $scope.lines.push(PathStyle);
 }
 function clickroute(lat,lng) {
  var latLng = new google.maps.LatLng(lat, lng);
  map.panTo(latLng);
  google.maps.event.addListenerOnce(map, 'bounds_changed', function(/*event*/) {
   if (map.getZoom()) this.setZoom(12);
  });
 }
};
$scope.markers = [];
$scope.lines = [];
$scope.selected_ip = $scope.iPList[0]||"";
$scope.drawVisualTraceRoute($scope.iPList[0]);
function searchTextChange(text) {
 var id = document.querySelector('#autoCompleteId');
 L.trace('Text changed to--- ' + text);
 if(!text){
  setTimeout(function(){id.type ="url";id.focus()},0);
 }
}
function addDestination(val) {
 // L.trace("addDestination");
 if($scope.history_show)return;
 $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time,$rootScope.strings.cancel_btn);
 if(C11N.is_portal){
  $scope.selected_ip=val;
  TRACEROUTE.perform_traceroute_test($scope.test,JSON.stringify({"value" : val,"tid" : $scope.tid}));
  return;
 }
 L.trace('addDestination--- ' + val);
 NativeAPI.validate_host(val,function(e,r){
  $rootScope.hideBusyScreen();
  if(e) L.error({err:e},"Error at host validation");
  if(r && r.valid){
   $scope.selected_ip = val;
   //TODO : Need to remove get_json & performTest_Fix functions from global
   WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup, { header: $rootScope.strings.wifi_internet_congestion ,
    body:  $rootScope.strings.wifi_always_check_congestion, btn_two:$rootScope.strings.no_btn, btn_one: $rootScope.strings.yes_btn,
    cb_two: function(){
     L.trace("visual traceroute host adding - NO");
     performTest_Fix($scope.test,JSON.stringify({"value" : val,"tid" : $scope.tid}));
     $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time,$rootScope.strings.cancel_btn);
     sendAnalyticsInfo({id:software_use_events.retest,details:$scope.test});
    },
    cb_one: function(){
     get_json("user_settings.servers.app_servers",function(e,app_ser){
     if(e && !isNoDataError(e)) return L.error({err:e},"addTraceRouteDestination-error");
     var bSave = true;
     var last = 0;
     if(app_ser) {
      var obj_keys = Object.keys(app_ser);
      bSave = !obj_keys.some(function(x){return app_ser[x]== val});
      last = +obj_keys.pop()||0;
     }
     if(bSave) SUTIL.setSetting("servers.app_servers",""+(last+1),val);
     performTest_Fix($scope.test,JSON.stringify({"value" : val,"tid" : $scope.tid}));
     $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time,$rootScope.strings.cancel_btn);
     sendAnalyticsInfo({id:software_use_events.retest,details:$scope.test});
     });
    }
   });
  }
  else{
   WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header:$rootScope.strings.trace_route_invalid_entry, body: $rootScope.strings.trace_route_valid_host_example , btn_one: $rootScope.strings.ok_btn});
   $scope.select_field = true;
   $scope.search_field = false;
  }
 });
}
function deleteHostAddressFromStorage(index) {
 if (index >= 0) {
  var ddValue = $scope.iPList[index];
  L.trace('deleteHostAddressFromStorage val--'+ddValue);
  get_json("user_settings.servers.app_servers",function(err,app_ser){
   if(err) return L.error("deleteHostAddressFromStorage-error-"+err);
   $scope.app_ser = app_ser;
   var res_key = Object.keys(app_ser).find(function(x){ return app_ser[x]==ddValue });
   if(res_key) {
    NativeAPI.deleteData("user_settings.servers.app_servers",res_key);
    NativeAPI.notify_settings_change("app_servers");
   }
   $scope.updatedropdownvalues();
  });
 }
}
function selectedItemChange(item) {
 L.trace("selectedItemChange--"+item);
 if(item){
  $scope.selected_ip = item;
  $scope.drawVisualTraceRoute(item);
 }
}
function querySearch (query) {
 L.trace("querySearch--"+query);
 return query ? $scope.iPList.filter( createFilterFor(query) ) : $scope.iPList;
}
function createFilterFor(query) {
 L.trace("createFilterFor--"+query);
 var lowercaseQuery = angular.lowercase(query);
 return function filterFn(item) {
  return (item.indexOf(lowercaseQuery) === 0);
 };
}
$scope.setTraceRouteDestinationList = function(app_ser) {
 $scope.app_ser = app_ser;
};
$scope.setIPList = function(ipList) {
 $scope.iPList = ipList;
 $scope.selectedItem = $scope.iPList[0];
 $rootScope.showBusyScreen($rootScope.strings.drawing_visual_route,$rootScope.strings.trace_route_takes_some_time);
};
/*$scope.onClickMap = function() {
 L.trace("app server list ---onClickMap ");
 //$scope.iPList = Object.keys(tr_data.results).map(function(x){ return x});
};*/
$scope.onOpenDropDown = function() {
 L.trace('onOpenDropDown');
 var id = document.querySelector('#autoCompleteId');
 $scope.searchText = "";
 setTimeout(function(){id.type ="url";id.focus()},0);
};
function process_app_servers_list(err,app_ser){
 if(err) return L.error("get Trace Route Destination List-error-"+err);
 var scope = angular.element($('#traceRouteScreen')).scope();
 if(scope) scope.setTraceRouteDestinationList(app_ser);
}
if(C11N.is_portal) $rootScope.get_json("user_settings.servers.app_servers",function(err, app_serv) {
 process_app_servers_list(err,app_serv);
});
else get_json("user_settings.servers.app_servers",function(err, app_serv) {
 process_app_servers_list(err,app_serv);
});
$scope.updatedropdownvalues = function updatedropdownvalues() {
 get_json("user_settings.servers.app_servers",function(err,app_ser){
  if(err) return L.error("updatedropdownvalues-error-"+err);
  /* var Storage_List = [];
  Storage_List.push(app_ser._default);
  Object.keys(app_ser.apps).map(function(x){  Storage_List.push(app_ser.apps[x])});
  app_ser.user && Object.keys(app_ser.user).map(function(x){  Storage_List.push(app_ser.user[x])});
  Object.keys(tr_data.results).map(function(x){if(Storage_List.indexOf(x) < 0) delete tr_data.results[x];});*/
  /* TODO: I'm dying to know what does .map(function(x){return x}) does */
  var scope = angular.element($('#traceRouteScreen')).scope();
  if(scope) {
   scope.setIPList(Object.keys(tr_data.results).map(function(x){return x}));
   scope.setTraceRouteDestinationList(app_ser);
  }
 });
};

}, false);
var TRACEROUTE = {
 perform_traceroute_test:null,
 draw_traceroute_for_user_ip : function drawTraceRouteforUserIp(){
  L.trace("drawTraceRouteforUserIp--host");
  var $scope = angular.element($('#traceRouteScreen')).scope();
  L.trace("history_show--"+$scope.history_show);
  if(!($scope && !$scope.history_show && is_google_maps_loaded())) return;
  $scope.fetch_traceroute_data();
 }
};

export default TRACEROUTE;
